import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import { Box } from '@mui/material';

import { COLOR_WHITE } from '../colors';

export const CustomExpandIcon = () => {
  return (
    <Box
      sx={{
        '.MuiSvgIcon-root': {
          color: COLOR_WHITE,
        },
        '.Mui-expanded & > .collapsIconWrapper': {
          display: 'none',
        },
        '.expandIconWrapper': {
          display: 'none',
        },
        '.Mui-expanded & > .expandIconWrapper': {
          display: 'block',
        },
      }}
    >
      <div className="expandIconWrapper">
        <RemoveRoundedIcon />
      </div>
      <div className="collapsIconWrapper">
        <AddRoundedIcon />
      </div>
    </Box>
  );
};
